module.exports = __webpack_public_path__ + "assets/img/extractionTarot.e9a86d1a.png";